import { Box, HStack, Text } from '@chakra-ui/react';

import { Error as ErrorIcon } from '@m/icons';

interface ReservationWindowErrorProps {
  message: string;
  /**
   * `card` — padded alert for form stacks (mobile / desktop home).
   * `inline` — icon + text only, for tight chrome (nav bar, results header).
   */
  variant?: 'card' | 'inline';
}

/**
 * Alert for invalid reservation start/end windows on discovery
 * (mobile form, desktop home, desktop park-now).
 */
export function ReservationWindowError({ message, variant = 'card' }: ReservationWindowErrorProps) {
  if (variant === 'inline') {
    return (
      <HStack role="alert" align="flex-start" gap="1.5" w="full" color="text.error">
        <Box
          as="span"
          flexShrink={0}
          mt="0.5"
          fontSize="16px"
          lineHeight="1"
          color="fill.icon.error"
          aria-hidden
        >
          <ErrorIcon />
        </Box>
        <Text variant="SmallBodyMedium" color="text.error">
          {message}
        </Text>
      </HStack>
    );
  }

  return (
    <HStack
      role="alert"
      align="flex-start"
      gap="2"
      w="full"
      px="3"
      py="2.5"
      borderRadius="md"
      bg="fill.background.error"
      borderWidth="1px"
      borderColor="stroke.border.error"
    >
      <Box
        as="span"
        flexShrink={0}
        mt="0.5"
        fontSize="20px"
        lineHeight="1"
        color="fill.icon.error"
        aria-hidden
      >
        <ErrorIcon />
      </Box>
      <Text variant="SmallBodyMedium" color="text.error" pt="0.5">
        {message}
      </Text>
    </HStack>
  );
}
